import {
    Checkbox,
    Dropdown,
    Flex,
    InputLabel,
    Text,
} from "@fluentui/react-northstar";
import React from "react";
import { Controller, useFormContext } from "react-hook-form";
import { DEVICE } from "../../../../constants/responsive";
import styled from "styled-components";
import { AVATAR_DEFAULT } from "../../../../constants";
import PillListEmployeeSelected from "../../../leave/components/absences/FilterHistoryAjustment/PillListEmployeeSelected";
import { generate_tabs_offboarding } from "../../constant";

export const ContentExportOffboarding = ({
    employees,
    onDeselectUserOrDeparment = () => null,
}) => {
    const {
        control,
        watch,
        setValue,
        getValues,
        formState: { errors },
    } = useFormContext();
    const onDismiss = (_, data) => {
        const uid = data.uid;
        onDeselectUserOrDeparment(uid);
    };

    const { tabs_array } = generate_tabs_offboarding();
    // formater les datas des departement et employees

    const format_employees = () => {
        return employees
            ?.map((empl) => ({
                id: empl?.id,
                key: empl?.id,
                header: empl?.name,
                image: empl?.avatar ? empl?.avatar : AVATAR_DEFAULT,

                content: empl.job_title,
            }))
            .sort((a, b) => b.id - a.id);
    };
    const formated_employees = format_employees();

    const watch_employees = watch("employee");
    const watch_checkboxes_status = watch("checkboxes_status");

    const selectAllOrDeselectAllStatus = (e, { checked }) => {
        if (checked) {
            setValue(
                "checkboxes_status",
                tabs_array.map((e) => e?.id)
            );
            return;
        } else {
            setValue("checkboxes_status", []);
            return;
        }
    };
    const addOrRemoveCheckedStatus = (id, checked) => {
        if (!checked) {
            // uncheck it
            const new_state = watch_checkboxes_status.filter(
                (cb_id) => cb_id !== id
            );
            setValue("checkboxes_status", new_state);
        } else {
            // check it
            const new_array = [...watch_checkboxes_status, id];
            setValue("checkboxes_status", new_array);
        }
        return;
    };
    return (
        <Flex fill>
            <Flex fill column>
                <InputLabel
                    content={"Collaborateur(s) ou département(s) concerné(s)"}
                />
                <Controller
                    name="employee"
                    control={control}
                    render={({ field: { onChange, value, ref } }) => {
                        return (
                            <DropdownEmployees
                                items={formated_employees}
                                placeholder={"Tous les collaborateurs"}
                                noResultsMessage="Aucun résultat."
                                positionFixed={true}
                                renderSelectedItem={() => null}
                                onChange={(e, i) => {
                                    onChange(i?.value);
                                }}
                                value={value}
                                ref={ref}
                                multiple
                                search
                            />
                        );
                    }}
                />
                <PillListEmployeeSelected
                    selectedEmployees={watch_employees}
                    onDismiss={onDismiss}
                />
                <Flex column styles={{ marginTop: "16px" }}>
                    <InputLabel content={"Statut(s) des collaborateurs"} />
                    <Flex column>
                        <Checkbox
                            label="Toutes"
                            onChange={selectAllOrDeselectAllStatus}
                            checked={
                                watch_checkboxes_status.length ===
                                tabs_array.length
                                    ? true
                                    : watch_checkboxes_status.length > 0
                                    ? "mixed"
                                    : false
                            }
                        />
                        <WrapperCheckboxes gap="gap.small">
                            {tabs_array?.map((status) => {
                                return (
                                    <Checkbox
                                        key={status.id}
                                        onChange={(e, { checked }) =>
                                            addOrRemoveCheckedStatus(
                                                status.id,
                                                checked
                                            )
                                        }
                                        checked={watch_checkboxes_status.includes(
                                            status.id
                                        )}
                                        label={status.label}
                                    />
                                );
                            })}
                        </WrapperCheckboxes>
                    </Flex>
                </Flex>
            </Flex>
        </Flex>
    );
};

const DropdownEmployees = styled(Dropdown)`
    @media ${DEVICE.mobileS} {
        .ui-dropdown__container {
            width: 100%;
        }
    }
    @media ${DEVICE.mobileL} {
        .ui-dropdown__container {
            /* width: 365px; */
        }
    }
`;

export const WrapperCheckboxes = styled(Flex)`
    flex-wrap: wrap;
    @media ${DEVICE.mobileS} {
        flex-direction: column;
    }
    @media ${DEVICE.tablet} {
        flex-direction: row;
    }
`;
